import { Component, input, inject } from '@angular/core';
import { BrnTabsDirective } from '@spartan-ng/ui-tabs-brain';
import { BehaviorSubject } from 'rxjs';
import { HlmTabsService } from './hlm-tabs.service';

@Component({
  selector: 'hlm-tabs',
  standalone: true,
  hostDirectives: [
    {
      directive: BrnTabsDirective,
      inputs: ['orientation', 'direction', 'activationMode', 'brnTabs: tab'],
      outputs: ['tabActivated'],
    },
  ],
  template: '<ng-content/>',
})
export class HlmTabsComponent {
  private brnTabsDirective = inject(BrnTabsDirective, { optional: true, host: true });
  private hlmTabsService = inject(HlmTabsService, { optional: true });

  public currentTab = '0';
  public readonly tabId = input<string>('');

  constructor() {
    const brnTabsDirective = this.brnTabsDirective;
    const hlmTabsService = this.hlmTabsService;

    // This is used only in the workflow ui in order to persist active tabs on config changes as the active config will store the current selected tabs on the page being shown
    if (brnTabsDirective && hlmTabsService) {
      // init the subject if it does not exist currently
      if (!hlmTabsService.activeTabSubjects.get(this.tabId())) {
        hlmTabsService.activeTabSubjects.set(this.tabId(), new BehaviorSubject<string>('0'));
      }

      brnTabsDirective.tabActivated.subscribe((newActiveTab) => {
        if (newActiveTab !== this.currentTab) {
          this.currentTab = newActiveTab;
          hlmTabsService.setActiveTab(this.tabId(), newActiveTab);
        }
      });

      hlmTabsService.activeTabSubjects.get(this.tabId())?.subscribe((newActiveTab) => {
        if (newActiveTab !== this.currentTab) {
          this.currentTab = newActiveTab;
          brnTabsDirective?.setActiveTab(newActiveTab);
        }
      });
    }
  }
}
